import { baseApi } from '@/features/api/baseApi';
import drawerReducer from '@/features/drawer/drawerSlice';
import driveReducer from '@/features/drive/driveSlice';
import {
  configureStore,
  type Action,
  type ThunkAction,
  type ThunkDispatch,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

export const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
  reducer: {
    drive: driveReducer,
    drawer: drawerReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;

setupListeners(store.dispatch);
